export function setReport (state, series) {
    state.analitycSeries = [...series]; 
}
export function setfilters (state, filters) {
  state.filters = {...filters};
}
export function setDates (state, dates) {
  state.dates  = {...dates}; 
}
export function setLoad (state, isLoadReport) {
  state.isLoadReport = isLoadReport;
}
export function setGeneralData (state, data) {
  state.generalData = {...data};
}